import { divide, flip } from 'ramda';

const divideBy = flip(divide);

export default divideBy;
